import { render } from "./Star.vue?vue&type=template&id=7b85efb6"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"

import "./Star.vue?vue&type=style&index=0&id=7b85efb6&lang=css"
script.render = render

export default script